export default (props, vars) =>
  props?.['applicationOffer']?.['is_neutral']
    ? `Check out your offer letter below for your ${props?.['applicationOffer']?.['job_name']} by Extern in partnership with ${props?.['applicationOffer']?.['company_name']}`
    : `Check out your offer letter below for your ${props?.['applicationOffer']?.['job_name']} by ${props?.['applicationOffer']?.['company_name']} in partnership with Extern.`;
